<template>
    <div>
        <div class="page-content-container">
            <div class="page-person-header">
                {{ username }}的学习报告
            </div>
            <div class="plan-title-wrapper">
                <div v-if="activePlan.status == 1" class="plan-title-state1">待开始</div>
                <div v-if="activePlan.status == 2" class="plan-title-state2">进行中</div>
                <div v-if="activePlan.status == 3" class="plan-title-state3">已完成</div>
                <div v-if="activePlan.status == 4" class="plan-title-state1">到期未完成</div>
                <div class="plan-title-label">{{ activePlan.planName }}</div>
                <el-dropdown @command="handleDropdown">
                    <div class="el-dropdown-link compony-dropdown">
                        <div class="plan-title-change-btn">
                            <img src="@/assets/img/qiehuan.png" alt="" class="change-btn-img">
                            <span class="change-btn-label">切换</span>
                        </div>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(item, key) in optionsData" :key="'dropdown-' + key" :command="item">
                            <el-radio v-model="item.checked" :label="item.planId">
                                {{ item.planName }}
                            </el-radio>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div class="page-content-header">
                <div class="page-header-block"></div>
                <div class="page-content-header-item-active">课程完成情况</div>
            </div>
            <div class="finish-info-wrapper">
                <div class="finish-info-content">
                    <div class="finish-info-num">{{ finishInfo.finishedCount }}/{{ finishInfo.totalCount }}</div>
                    <div class="finish-info-label">总课程完成进度</div>
                </div>
                <div class="finish-progress-wrapper">
                    <div class="finish-progress" :style="`width:${finishInfo.finishedRate}%;`">
                        <div class="finish-progress-num"></div>
                    </div>
                </div>
                <div class="finish-progress-val">{{ finishInfo.finishedRate }}%</div>
            </div>
        </div>

        <div class="page-content-container" style="margin-top:18px;">
            <div class="page-content-header page-branch">
                <div class="page-header-block"></div>
                <div class="page-content-header-item-active">测评统计</div>
            </div>
            <div class="menmber-table-container">
                <div class="navbar-wrapper">
                    <div :class="activeNav == 'part' ? 'navbar-item-active' : 'navbar-item'" @click="handleNav('part')">
                        阶段测试
                        <div v-if="activeNav == 'part'" class="navbar-line-wrapper">
                            <div class="navbar-line"></div>
                        </div>
                    </div>
                    <div :class="activeNav == 'total' ? 'navbar-item-active' : 'navbar-item'" @click="handleNav('total')">
                        综合测试
                        <div v-if="activeNav == 'total'" class="navbar-line-wrapper">
                            <div class="navbar-line"></div>
                        </div>
                    </div>
                </div>

                <div class="table-container">
                    <div class="measure-table-wrapper">
                        <div class="measure-table-item">
                            <div class="measure-table-header row1 row-first">
                                试卷名称
                            </div>
                            <div class="measure-table-header row1">
                                分数（最高分）
                            </div>
                            <div class="measure-table-header row1 row-last">
                                操作
                            </div>
                        </div>
                        <div v-for="(item, index) in tableData" :key="'table-' + index" class="measure-table-item">
                            <div :class="index % 2 == 1 ? 'measure-table-color row1' : 'measure-table-row row1'">
                                {{ item.metaExamName }}
                            </div>
                            <div :class="index % 2 == 1 ? 'measure-table-color row1' : 'measure-table-row row1'">
                                {{ item.userScore === -1 ? '--' : item.userScore }}
                            </div>
                            <div
                                :class="index % 2 == 1 ? 'measure-table-color row1 table-operate' : 'measure-table-row row1 table-operate'">
                                <!-- <div class="table-operate-item" @click="viewRecord(item)">考试记录</div> -->
                                <!-- <div class="table-operate-item" @click="courseDetail(item)">课程详情{{
                                    activePlan.skipCourse }}
                                </div> -->
                                <el-button type="primary" plain @click="viewRecord(item)">考试记录</el-button>
                                <el-button type="primary" plain @click="courseDetail(item)"
                                    :disabled="activePlan.skipCourse == 1">课程详情</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="page-content-container" style="margin-top:18px;">
            <div class="page-content-header-study-detail page-branch">
                <div class="page-header-block"></div>
                <div class="page-content-header-item-study-detail">学习详情</div>
            </div>
            <div>
                <div class="study-detail-container">
                    <div class="study-detail-wrapper">
                        <div v-for="(item, key) in listData" :key="key" class="study-list-item">
                            <div class="table-content">
                                <div class="table-header">
                                    {{ item.courseName }}
                                </div>
                                <div class="table-date">
                                    视频
                                    <div class="table-date-line"></div>
                                    {{ item.courseTime }}分钟
                                </div>
                                <div class="table-info-wrapper">
                                    <div class="table-info-item">
                                        <div class="table-info-title">要求进度</div>
                                        <div class="table-info-value">
                                            <span v-if="item.requiredProgress == 100" style="color:#FF9645;">
                                                {{ item.requiredProgress }}%
                                            </span>
                                            <span v-else style="color:#3E63EE;">
                                                {{ item.requiredProgress }}%
                                            </span>
                                        </div>
                                    </div>
                                    <div class="table-info-item">
                                        <div class="table-info-title">学习进度</div>
                                        <div class="table-info-value">
                                            <span v-if="item.studyProgress == 100" style="color:#FF9645;">
                                                {{ item.studyProgress }}%
                                            </span>
                                            <span v-else style="color:#3E63EE;">
                                                {{ item.studyProgress }}%
                                            </span>
                                        </div>
                                    </div>
                                    <div class="table-info-item">
                                        <div class="table-info-title">上次学习</div>
                                        <div class="table-info-value">
                                            {{ item.lastStudyTime }}
                                        </div>
                                    </div>
                                    <div class="table-info-item">
                                        <div class="table-info-title">完成日期</div>
                                        <div class="table-info-value">
                                            {{ item.finishedTime }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="listData.length > 0 && currentPage < totalPages" class="view-more-btn" @click="viewMore">查看更多
                    </div>
                </div>
            </div>
        </div>

        <el-dialog title="" :show-close="true" width="1250px" top="57px" :visible.sync="recordDialog"
            class="dialog-container">
            <div class="dialog-header">
                <div>考试记录</div>
            </div>
            <div class="dialog-content-wrapper">
                <div class="dialog-content">
                    <div class="table-container">
                        <div class="table-wrapper">
                            <table border>
                                <tr class="table-header">
                                    <td>考试次数</td>
                                    <td>考试分数</td>
                                    <td>做题时长</td>
                                    <td style="width:40%;">交卷时间</td>
                                </tr>
                                <tr v-for="(item, index) in recordDetailList" :key="'examRecord-' + index">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ item.userScore }}</td>
                                    <td>{{ resetTimes(item.userSpendTime) }}</td>
                                    <td>{{ item.userExamEndTime }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        </el-dialog>


        <el-dialog title="" :show-close="true" width="1250px" top="57px" :visible.sync="echartsDialog"
            class="dialog-container">
            <div class="dialog-header">
                <div>课程详情</div>
            </div>
            <div class="dialog-content">
                <div v-for="(item, key) in courseRuleData" :key="key" class="course-rule-container">
                    <div class="course-rule-wrapper">
                        <div class="course-rule-title">
                            {{ item.courseName }}
                        </div>
                        <div class="course-rule-brief">
                            <div class="course-rule-brief-label">视频</div>
                            <div class="course-rule-line"></div>
                            <div>{{ item.courseTime }}分钟</div>
                        </div>
                        <div class="course-rule-content">
                            <div>
                                <div>需求进度</div>
                                <div class="course-rule-content-val" style="color:#3E63EE;">
                                    {{ item.requiredProgress }}%
                                </div>
                            </div>
                            <div class="course-rule-content-line"></div>
                            <div>
                                <div>学习进度</div>
                                <div class="course-rule-content-val" style="color:#FF9645;">
                                    {{ item.studyProgress }}%
                                </div>
                            </div>
                            <div class="course-rule-content-line"></div>
                            <div>
                                <div>上次学习</div>
                                <div class="course-rule-content-val">{{ item.lastStudyTime }}</div>
                            </div>
                            <div class="course-rule-content-line"></div>
                            <div>
                                <div>完成日期</div>
                                <div class="course-rule-content-val">{{ item.finishedTime }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pagination-wrap">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page.sync="pageNum" :page-size="pageSize" layout="total, prev, pager, next" :total="total">
                    </el-pagination>
                </div>
            </div>
            <!-- <div class="dialog-content-wrapper">
                <div class="dialog-content">
                    <div class="dialog-search-wrapper">
                        <el-input
                            v-model="echartSearchVal" aria-placeholder="输入成员姓名/电话">
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                        <div class="search-btn" @click="searchEchartSearchList">搜索</div>
                    </div>

                    <div class="table-container">
                        <div class="table-wrapper">
                            <table border>
                                <tr class="table-header">
                                    <td>姓名</td>
                                    <td>手机号</td>
                                    <td style="width:40%;">所属公司部门</td>
                                    <td>操作</td>
                                </tr>
                                <tr v-for="(item,key) in echartDetailList" :key="key">
                                    <td>{{item.userName}}</td>
                                    <td>{{item.mobile}}</td>
                                    <td>{{item.deptName}}</td>
                                    <td class="echartDetailBtn" @click="viewReport(item)">查看报告</td>
                                </tr>
                            </table>
                        </div>
                    </div>

                </div> 
            </div>-->
        </el-dialog>

    </div>
</template>

<script>
import {
    getMemberDetailStatistics,
    userPlanList,
    userPlanFinishState,
    partPlanStatisticsList,
    totalPlanStatisticsList,
    myPlanCourseList,
    stageExamRecordList,
    examRecordList,
    planStudyUserList,
    myStageExamStudyCourseList,
    userStageExamStudyCourseList,
    userStudyCourseList
} from '@/api/index.js';

export default {
    name: '',
    components: {

    },
    data() {
        return {
            dept: '',
            token: "",
            userDept: '',
            userId: 0,
            username: '',
            activePlan: {
                planName: '暂无计划',
                status: 1
            },
            optionsData: [],
            statisticsInfo: {},
            finishInfo: {},
            activeNav: 'part',
            currentPage: 1,
            totalPages: 1,
            tableData: [],
            listData: [],
            recordDialog: false,
            recordDetailList: [],
            echartsDialog: false,
            courseRuleData: [],
            echartSearchVal: '',
            echartDetailList: [],
            pageNum: 1,
            pageSize: 10,
            total: 0,
        }
    },
    created() {
        scrollTo(0, 0);
        this.userId = this.$route.params.id;
        //this.dept = this.$route.params.dept;
         this.dept = window.localStorage.getItem('dept');
        this.userDept = this.$route.params.userDept;
        this.token = window.localStorage.getItem('token');
    },
    mounted() {
        this.statisticsData();
        this.getUserPlanList();
    },
    methods: {
        statisticsData() {
            getMemberDetailStatistics(this.userDept, this.userId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    this.username = data.name;
                    this.statisticsInfo = data;
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        getUserPlanList() {
            userPlanList(this.userDept, this.userId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    var _this = this;
                    this.optionsData = data.map(function (item, index) {
                        if (index == 0) {
                            item['checked'] = item.planId;
                            _this.activePlan = item;
                            _this.getUserPlanFinishState();
                            _this.getPartPlanStatisticsList();
                            _this.getStudyList();
                        } else {
                            item['checked'] = '';
                        }
                        return item;
                    });
                }

                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        getUserPlanFinishState() {
            userPlanFinishState(this.activePlan.planId, this.userId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    this.finishInfo = data;
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        viewRecord(row) {
            var mode = this.activeNav;
            switch (mode) {
                case 'part':
                    stageExamRecordList(row.metaExamId, this.userId, {}, {
                        Authorization: this.token,
                        DeptId: this.dept
                    }).then(res => {
                        if (res.code == 200) {
                            var data = res.data;
                            this.recordDetailList = data;
                            this.recordDialog = true;
                        }
                        return;
                    }).catch(err => {
                        // console.log(err);
                    });
                    break;
                case 'total':
                    examRecordList(row.metaExamId, this.userId, {}, {
                        Authorization: this.token,
                        DeptId: this.dept
                    }).then(res => {
                        if (res.code == 200) {
                            var data = res.data;
                            this.recordDetailList = data;
                            this.recordDialog = true;
                        }
                        return;
                    }).catch(err => {
                        // console.log(err);
                    });
                    break;
            }
        },
        courseDetail(row) {
            // planStudyUserList({
            //     "deptId": 0,
            //     "keyword": this.echartSearchVal,
            //     "pageNum": 1,
            //     "pageSize": 10000,
            //     "planId": this.activePlan.planId,
            //     "status": 0,
            //     "userId": 0
            // },{
            //     Authorization:this.token,
            //     DeptId:this.dept
            // }).then(res => {
            //     if(res.code==200){
            //         var data=res.data;
            //         this.echartDetailList=data.list;
            //         this.echartsDialog=true;
            //     }
            //     return;
            // }).catch(err => {
            //    // console.log(err);
            // });
            let reqMethod = userStageExamStudyCourseList
            if (this.activeNav == 'total') { // 综合
                reqMethod = userStudyCourseList
            }
            reqMethod({
                deptId: this.dept,
                keyword: '',
                metaExamId: row.metaExamId,
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                planId: this.activePlan.planId,
                userId: this.userId
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.courseRuleData = res.data.list;
                    this.total = res.data.totalRecords
                    this.echartsDialog = true;
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        handleDropdown(row) {
            var optionsData = this.optionsData;
            var newArr = [];
            for (var i = 0; i < optionsData.length; i++) {
                var item = optionsData[i];
                if (item.planId == row.planId) {
                    item.checked = row.planId;
                    this.activePlan = item;
                } else {
                    item.checked = '';
                }
                newArr.push(item);
                if (i == optionsData.length - 1) {
                    this.optionsData = newArr;
                    this.getUserPlanFinishState();
                    this.getPartPlanStatisticsList();
                    this.getStudyList();
                }
            }
            console.log(newArr, '****bjsjksbk');
        },
        handleNav(target) {
            this.activeNav = target;
            switch (target) {
                case 'part':
                    this.getPartPlanStatisticsList();
                    break;
                case 'total':
                    this.getTotalPlanStatisticsList();
                    break;
            }
        },
        getPartPlanStatisticsList() {
            partPlanStatisticsList(this.activePlan.planId, this.userId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    this.tableData = data;

                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        getTotalPlanStatisticsList() {
            totalPlanStatisticsList(this.activePlan.planId, this.userId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    this.tableData = data;
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        getStudyList() {
            userStudyCourseList({
                "deptId": this.dept,
                "keyword": "",
                "pageNum": 1,
                "pageSize": 10000,
                "planId": this.activePlan.planId,
                "userId": Number(this.userId)
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.listData = res.data.list;
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        resetTimes(time) {
            var hours = parseInt(time / 3600);
            var hoursRum = time % 3600;
            var minutes = parseInt(hoursRum / 60);
            var seconds = hoursRum % 60;
            if (hours < 10) {
                hours = '0' + hours;
            }
            if (minutes < 10) {
                minutes = '0' + minutes;
            }
            if (seconds < 10) {
                seconds = '0' + seconds;
            }
            return `${hours}:${minutes}:${seconds}`;
        },
        searchEchartSearchList() {
            this.getStudyList();
        },
        viewReport(row) {
            this.$emit('reportRow', JSON.stringify(row));
        },
        viewMore() {

        },
        handleSizeChange(val) {
            this.pageSize = val
        },
        handleCurrentChange(val) {
            this.pageNum = val
        }
    }
}
</script>

<style scoped>
.page-content-container {
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #F0F0F3;
}

.page-person-header {
    font-size: 22px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    padding: 30px 0px 0px 0px;
    text-align: center;
}

.page-content-header {
    width: 100%;
    height: 80px;
    line-height: 80px;
    position: relative;
    display: flex;
    align-items: center;
}

.page-content-header-study-detail {
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
}

.page-header-block {
    width: 6px;
    height: 24px;
    background: #4F79ED;
    border-radius: 0px 17px 17px 0px;
    position: absolute;
    left: 0px;
    top: 28px;
}

.page-content-header-item-active {
    height: 100%;
    text-align: center;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #4F79ED;
    background: #fff;
    cursor: pointer;
    margin-left: 45px;
}

.page-content-header-item-study-detail {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #4F79ED;
    background: #fff;
    position: relative;
    margin-left: 45px;
    margin-top: 25px;
}

.plan-title-wrapper {
    display: flex;
    align-items: center;
    margin-left: 45px;
    margin-top: 34px;
}

.plan-title-state1 {
    width: 92px;
    height: 24px;
    background: #9B9FAA;
    border-radius: 6px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 12px;
}

.plan-title-state2 {
    width: 72px;
    height: 24px;
    background: #FF9645;
    border-radius: 6px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 12px;
}

.plan-title-state3 {
    width: 72px;
    height: 24px;
    background: #67C23A;
    border-radius: 6px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 12px;
}

.plan-title-label {
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    margin-right: 12px;
}

.plan-title-change-btn {
    width: 96px;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #3E63EE;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3E63EE;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.plan-title-change-btn:hover {
    cursor: pointer;
    opacity: 0.8;
}

.change-btn-img {
    width: 20px;
    height: 19px;
}

.change-btn-label {
    margin-left: 8px;
}

.finish-info-wrapper {
    width: 912px;
    height: 130px;
    background: #FFFFFF;
    border-radius: 9px;
    border: 1px solid #D8D8EA;
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.finish-info-content {
    margin-left: 30px;
}

.finish-info-num {
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3E63EE;
}

.finish-info-label {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606A74;
    margin-top: 5px;
}

.finish-progress-wrapper {
    position: relative;
    flex: 1;
    height: 30px;
    background: rgba(79, 121, 237, 0.3);
    border-radius: 15px;
    opacity: 0.6;
    margin-left: 30px;
    margin-right: 30px;
}

.finish-progress {
    position: absolute;
    left: 0px;
    top: 0px;
    height: 30px;
    background: #3E63EE;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.finish-progress-val {
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3E63EE;
    margin-right: 30px;
}

.finish-progress-num {
    font-size: 22px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
}

.navbar-wrapper {
    display: flex;
    height: 44px;
    margin-left: 45px;
    margin-right: 45px;
    border-bottom: 1px solid #F0F0F0;
}

.navbar-item {
    height: 100%;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    margin-right: 34px;
    position: relative;
    cursor: pointer;
}

.navbar-item-active {
    height: 100%;
    font-size: 22px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #666666;
    margin-right: 34px;
    position: relative;
    cursor: pointer;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.navbar-line-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: -3px;
    left: 0px;
}

.navbar-line {
    width: 22px;
    height: 6px;
    background: #3E63EE;
    border-radius: 3px;
}

.table-container {
    display: flex;
    margin-top: 32px;
}

.study-detail-container {
    display: flex;
}

.study-detail-wrapper {
    flex: 1;
    margin-left: 45px;
    margin-right: 45px;
    margin-bottom: 50px;
}

.measure-table-wrapper {
    flex: 1;
    background: #fff;
    margin-left: 45px;
    margin-right: 45px;
    margin: 0px 45px 50px 45px;
}

.measure-table-item {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.measure-table-header {
    height: 64px;
    background: #FFBA85;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 2px;
}

.measure-table-row {
    height: 64px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 2px;
    background: #F8F8F8;
}

.measure-table-color {
    height: 64px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606A74;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 2px;
    background: #FFE5D1;
    ;
}

.row1 {
    flex: 1;
}

.row2 {
    flex: 1.5;
}

.row3 {
    flex: 2;
}

.row-first {
    border-radius: 16px 0px 0px 0px;
}

.row-last {
    border-radius: 0px 16px 0px 0px;
}

.table-icon {
    color: #333333;
    margin-left: 3px;
    cursor: pointer;
}

.table-operate {
    color: #4F79ED;
}

.table-operate-item:hover {
    cursor: pointer;
    opacity: 0.8;
}

.table-content {
    width: 726px;
}

.table-header {
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
}

.table-date {
    margin-top: 8px;
    display: flex;
    align-content: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606A74;
}

.table-date-line {
    width: 1px;
    height: 14px;
    background: #D7D7D7;
    margin: 0px 8px 0px 8px;
    position: relative;
    top: 4px;
}

.table-info-wrapper {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
}

.table-info-item {
    flex: 1;
    color: #606A74;
}

.table-info-title {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
}

.table-info-value {
    margin-top: 6px;
}

.table-btn {
    width: 108px;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #3E63EE;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3E63EE;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 11px;
    margin-left: 20px;
}

.table-btn:hover {
    cursor: pointer;
    background: #3E63EE;
    color: #fff;
}

.table-btn-state {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    margin-top: 6px;
}

.study-list-item {
    display: flex;
    justify-content: space-between;
    padding-top: 35px;
    padding-bottom: 29px;
    border-bottom: 1px solid #F0F0F0;
}

/* .dialog-container>>>.el-dialog__body{ 
    padding: 0px !important;
}
.dialog-container>>>.el-dialog__header{
    padding: 0px !important;
}
.dialog-content>>>.el-form-item__label{
    text-align: left !important;
    font-size: 16px !important;
    font-family: PingFangSC-Regular, PingFang SC !important;
    color: #333333 !important;
}
.dialog-content>>>.el-input__inner{
    height: 40px !important;
    background: #FFFFFF !important;
    border-radius: 6px !important;
    border: 1px solid #D9D9D9 !important;
}
.dialog-header{
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    margin-left:45px;
    padding-top:32px;
}
.dialog-content-wrapper{
    display:flex;
}
.dialog-content{
    flex:1;
    margin:20px 40px 40px 40px;
} 
.dialog-search-wrapper{
    display:flex;
    justify-content: space-between;
}
*/
.dialog-container>>>.el-dialog__body {
    padding: 0px !important;
}

.dialog-container>>>.el-dialog__header {
    padding: 0px !important;
}

.dialog-header {
    width: 100%;
    height: 59px;
    background: #F8FAFF;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
}

.dialog-content {
    padding: 46px 77px 60px 77px;
}

.dialog-btn-wrapper {
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
}

.one-btn-wrapper {
    justify-content: center;
}

.dialog-content>>>.el-button {
    width: 148px !important;
    height: 40px !important;
    line-height: 40px !important;
    border-radius: 6px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 18px !important;
    font-family: PingFangSC-Regular, PingFang SC !important;
}

.dialog-content>>>.el-button--primary {
    background: linear-gradient(90deg, #5580F5 0%, #72A3F5 100%) !important;
}

.dialog-content>>>.el-button--default {
    border: 1px solid #4F79ED;
    color: #4F79ED !important;
}

.course-rule-container {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
}

.pagination-wrap {
    display: flex;
    justify-content: flex-end;
}

.course-rule-wrapper {
    width: 726px;
    position: relative;
}

.course-rule-brief {
    display: flex;
    margin-top: 8px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606A74;
}

.course-rule-brief-label {
    width: 40px;
    margin-right: 8px;
}

.course-rule-line {
    width: 1px;
    height: 14px;
    background: #D7D7D7;
    margin-right: 10px;
    position: relative;
    top: 4px;
}

.course-rule-content {
    display: flex;
    margin-top: 16px;
    padding-bottom: 29px;
    border-bottom: solid #F0F0F0 1px;
}

.course-rule-title {
    width: 100%;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.course-rule-content-line {
    width: 1px;
    height: 35px;
    background: #E4E4E4;
    margin-left: 43px;
    margin-right: 43px;
}

.course-rule-content-val {
    font-size: 18px;
    margin-top: 5px;
}

.table-container {
    width: 100%;
}

.table-wrapper {
    width: 100%;
    margin-top: 34px;
}

table {
    width: 100%;
    border: 1px solid #CBCBCB;
    border-collapse: collapse;
}

td {
    height: 60px;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606A74;
    text-align: center;
}

.table-header td {
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    background: rgb(248, 248, 248);
}

.dialog-search-wrapper {
    display: flex;
    justify-content: space-between;
}

.search-btn {
    width: 92px;
    height: 38px;
    border-radius: 6px;
    border: 1px solid #C1C1C1;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 16px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.search-btn:hover {
    cursor: pointer;
    color: #3E63EE;
    border: solid #3E63EE 1px;
}

.echartDetailBtn {
    color: #3E63EE;
}

.echartDetailBtn:hover {
    cursor: pointer;
    opacity: 0.8;
}
</style>


